var Keysets;
(function (Keysets) {
  Keysets[Keysets["ComboboxDiv"] = 0] = "ComboboxDiv";
  Keysets[Keysets["ComboboxInput"] = 1] = "ComboboxInput";
})(Keysets || (Keysets = {}));
export { Keysets };